import { shouldShowRatingsAndReviewsV2 } from 'src/utils/app';

export const beaconBasicCards = [
  [
    ['sales', 'retailSales', 'sales', 'retailSales'],
    ['sales', 'unitsSold', 'sales', 'unitsSold'],
    ['sales', 'wholesaleSales', 'sales', 'retailSales'],
    ['sales', 'retailerGrossMargin', 'sales', 'retailerGrossMargin'],
    ['sales', 'returnRate', 'sales', 'returnRate']
  ],
  [
    ['advertising', 'spend', 'traffic', 'adClicks'],
    ['advertising', 'sales', 'traffic', 'adClicks'],
    ['advertising', 'clicks', 'traffic', 'adClicks'],
    ['advertising', 'costPerClick', 'traffic', 'adClicks'],
    ['advertising', 'returnOnAdSpend', 'traffic', 'adClicks']
  ],
  [
    ['sales', 'retailPrice', 'sales', 'retailPrice'],
    ['new-content-metrics', 'contentScore', 'content', 'contentScore'],
    shouldShowRatingsAndReviewsV2()
      ? ['ratings-reviews-metrics-v2', 'weeklyReviewVolume', 'reviews', 'reviews'] // reviewTrends or Review-Summary is for pro only
      : ['reviews', 'stars', 'reviews', 'reviews'], // reviewTrends or Review-Summary is for pro only
    ['sales', 'instockRate', 'sales', 'inventory'],
    ['sales', 'stacklineSku', 'sales', 'unitsSold']
  ]
];

export const beaconProCards = [
  [
    ['traffic', 'totalClicks', 'traffic', 'totalClicks'],
    ['aggregated-traffic', 'organicClicks', 'traffic', 'organicClicks'],
    ['advertising', 'clicks', 'traffic', 'adClicks'],
    ['advertising', 'spend', 'traffic', 'adClicks'],
    ['advertising', 'sales', 'traffic', 'adClicks'],
    ['advertising', 'returnOnAdSpend', 'traffic', 'adClicks']
  ],
  [
    ['sales', 'purchaseRate', 'conversion', 'purchaseRate'],
    ['sales', 'retailPrice', 'sales', 'retailPrice'],
    ['new-content-metrics', 'contentScore', 'contentV2', 'contentSummary'],
    ['sales', 'instockRate', 'sales', 'inventory'],
    shouldShowRatingsAndReviewsV2()
      ? ['ratings-reviews-metrics-v2', 'weeklyReviewVolume', 'reviews', 'reviewTrends']
      : ['reviews', 'stars', 'reviews', 'reviewTrends'],
    ['buybox', 'winPercentage', 'buybox', 'winPercentage']
  ],
  [
    ['sales', 'retailSales', 'sales', 'retailSales'],
    ['sales', 'unitsSold', 'sales', 'unitsSold'],
    ['sales', 'wholesaleSales', 'sales', 'retailSales'],
    ['sales', 'retailerGrossMargin', 'sales', 'retailerGrossMargin'],
    ['sales', 'brandGrossMargin', 'sales', 'retailerGrossMargin'],
    ['sales', 'stacklineSku', 'sales', 'unitsSold']
  ]
];
